import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import FirstSectionStore from './store';
import cx from 'classnames';
// import AgeAppropriateTips from '@src/components/age-appropriate-tips';
import Link from '@src/components/link';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';

const pageLocalesData = getPageLocalesData();

const styles = require('./index.less');

const FirstSection = ({ store }) => {
  store.use();

  const AppointmentBtnText = () => {
    if (store.downLoadBtnState) {
      return (
        <Link
          className={cx(styles.btn, styles.downloadBtn)}
          onClick={() => {
            store.aLinkSteam();
          }}
        >
          {/* 预约按钮改为：【参加Steam测试】 */}
          {pageLocalesData.main.firstSection.steamBtn1}
        </Link>
      );
    } else {
      return (
        <Link className={cx(styles.btn, styles.btn_Appointment)} onClick={() => store.onBook?.()}>
          {/* 立即预约 */}
          {pageLocalesData.main.firstSection.AppointmentBtn}
        </Link>
      );
    }
  };

  return (
    <div className={cx(styles.root, store.isActive && styles.rootAvtive)}>
      <div className={styles.kv}>
        <div className={styles.hud} />
        {/* <div className={styles.icon} /> */}
        <div className={styles.scroll} />
      </div>
      <div className={styles.firstScreenContainer}>
        {/* <div className={styles.tip_to_up} /> */}
        {/* <Link
          className={cx(styles.btn_video)}
          onClick={() => {
            store.playPvVideo();
          }}
        /> */}
        <div className={styles.sloganBox}>
          <div className={cx(styles.slogan)} />
        </div>
        {AppointmentBtnText()}
      </div>
    </div>
  );
};

export default wrapStore(FirstSection, FirstSectionStore);
